import * as React from 'react';
import styled from 'styled-components';
import animateScrollTo from 'animated-scroll-to';

import {COLORS, invertedFocusStyles} from '../../styles';
import Logo from '../../GlobalNavigationBar/Logo';
import {SystemIcons} from '../../icons';
import {ComponentTextStyle, ComponentXSStyling} from '../../styles';

const FooterTopSection = styled.section`
  min-height: 8px;
  color: white;
  display: flex;
  flex-direction: row;
  margin-bottom: 16px;
`;

const ToTop = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto 0 auto auto;
  border-radius: 4px;
  height: 48px;
  width: 48px;
  padding: 8px;

  svg {
    margin: 0 auto;
  }

  &:hover {
    cursor: pointer;
  }
  span {
    margin: 14px auto 0 auto;
    ${ComponentXSStyling(ComponentTextStyle.UppercaseBold, 'inherit')}
  }

  &:hover:not(:disabled) {
    background-color: ${COLORS.primary_20};
    svg path,
    svg {
      fill: ${COLORS.primary_700};
    }
    span {
      color: ${COLORS.primary_700};
    }
  }

  &:focus:not(:disabled) {
    ${invertedFocusStyles}
  }

  &:active:not(:disabled) {
    background: ${COLORS.primary_100};
    svg path,
    svg {
      fill: ${COLORS.primary_800};
    }
    span {
      color: ${COLORS.primary_800};
    }
  }
`;

interface FooterTopProps {
  sitename?: string;
  showBetaTag?: boolean;
  toTopText: string;
}

const FooterTop = ({ sitename, showBetaTag, toTopText }: FooterTopProps) => {
  const isPressingEnter = (e: any) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.stopPropagation();
      return true;
    }
    return false;
  };
  const action = () => {
    animateScrollTo(0);
  };
  return (
    <FooterTopSection>
      <Logo
        name={sitename || ''}
        showBetaTag={showBetaTag}
        color={COLORS.white}
        inverted={true}
        betaTagBackgroundColor={COLORS.white}
        betaTagColor={COLORS.neutral_800}
      />
      <ToTop data-testid={'toTopNavigation'} tabIndex={0} onKeyDown={(e: any) => (isPressingEnter(e) ? action() : null)} onClick={action}>
        <SystemIcons.ArrowLineUp size="24px" color={COLORS.white} />
        <span>{toTopText}</span>
      </ToTop>
    </FooterTopSection>
  );
};

export default FooterTop;
